import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (store.state.user.roles.length === 0 && to.fullPath.toLowerCase().indexOf('login') === -1) {
    // 判断当前用户是否已拉取完user_info信息
    new Promise((resolve) => {
      store.dispatch('formMenu', resolve)
    }).then(res => {
      // 拉取user_info
      const roles = store.state.user.roles
      const isAdmin = Number(store.state.user.isAdmin) === 1
      if (roles.length !== 0) {
        store.dispatch('GenerateRoutes', {
          roles: roles,
          isAdmin: isAdmin
        }).then(() => {
          // 生成可访问的路由表
          router.addRoutes(store.state.permission.addRouters) // 动态添加可访问路由表
          if (to.path === '/') {
            next({ path: roles[0].url })
          } else {
            next({ ...to })
          }
        })
      }
    }).catch(err => {
      console.info(err)
      next()
    })
  } else if (to.path === '/' && to.fullPath.toLowerCase().indexOf('login') === -1 && store.state.user.roles.length !== 0) {
    next({ path: store.state.user.roles[0].url })
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})
